module.exports = __webpack_public_path__ + "static/media/thealternator.2d71f133.jpg";